import { isTruthy } from "@vega-core/utils/isTruthy";

export function getLogo(
  theme: string,
  defaultLogo: string,
  companyLogoLight?: string,
  companyLogoDark?: string,
): string {
  switch (theme) {
    case "light":
      // Return 'companyLogoLight' if it exists, otherwise 'DEFAULT_LOGO'
      return isTruthy(companyLogoLight) ? companyLogoLight : defaultLogo;
    default:
      // Return 'companyLogoDark' if it exists, otherwise 'DEFAULT_LOGO'
      return isTruthy(companyLogoDark) ? companyLogoDark : defaultLogo;
  }
}
